import React, { Component } from 'react';
import withAuthorization from '../withAuthorization';
import EventList from './EventList'
import AddEvent from './AddEvent'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { withStyles } from '@material-ui/core/styles';
//import Button from '@material-ui/core/Button';
//import AddIcon from '@material-ui/icons/Add';
//import Tooltip from '@material-ui/core/Tooltip';
//import NavigationIcon from '@material-ui/icons/Navigation';
//import CounterBar from '../Counter/CounterBar'
import SubNav from '../SubNav/SubNav'
//import DefaultPage from '../../Container/Layout/DefaultPage'
const styles = theme => ({

});


class Events extends Component {
  constructor(props) {
    super(props);

    this.state   = {
      view: null, // default view EventList
    };
    this.toggleView = this.toggleView.bind(this)
  }

  toggleView(viewPage) {
    switch(viewPage) {
        case null : {
          this.setState({view: 'EVENTS'})
          break
        }
        case 'EVENT_DETAILS' : {
          this.setState({view: 'EVENT_DETAILS'})
          break
        }
        default : this.setState({view: null})
      }
    }

  render(){
  
    const { navState } = this.props
  
    return (
      <div>
        <SubNav />
          {navState === 1 && <AddEvent />}
          <EventList />
      </div>
)}}

const mapDispatchToProps = (dispatch) => ({
  onClickAddEvent: (value) => dispatch({ type: 'TOGGLE_ADDEVENT', value }),
})

const mapStateToProps = (state) => ({
  navState: state.appState.addEventState,
});


const authCondition = (authUser) => !!authUser;

export default compose(withAuthorization(authCondition),connect(mapStateToProps, mapDispatchToProps), withStyles(styles))(Events)


// WEBPACK FOOTER //
// ./src/Components/Events/Events.js